export default __webpack_public_path__ + "static/media/books.f47cf2dd.jpg";